import React, {memo} from "react";

export default memo(function RenderIf({children, isTrue}) {
  return Boolean(isTrue) === true ? children : null;
});
